<template>
  <el-dialog
    append-to-body
    width="600px"
    title="名片信息"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-descriptions
      title=""
      :column="1"
      border
      v-if="userInfo && userInfo.name"
      size="small"
    >
      <el-descriptions-item label="姓名" :labelStyle="labelStyle">{{
        userInfo.name
      }}</el-descriptions-item>
      <el-descriptions-item label="年龄" :labelStyle="labelStyle">{{
        userInfo.age
      }}</el-descriptions-item>
      <el-descriptions-item label="身份" :labelStyle="labelStyle">
        {{
          { 0: "未填", 1: "学生", 2: "自由职业", 3: "宝妈", 4: "全职" }[
            userInfo.type
          ]
        }}
      </el-descriptions-item>
      <el-descriptions-item label="擅长工种" :labelStyle="labelStyle">{{
        userInfo.kinds
      }}</el-descriptions-item>
      <el-descriptions-item label="联系电话" :labelStyle="labelStyle">{{
        userInfo.phone
      }}</el-descriptions-item>
      <el-descriptions-item label="所在地址" :labelStyle="labelStyle">
        <div>{{ userInfo.map_address }}</div>
      </el-descriptions-item>
      <el-descriptions-item label="服务地区" :labelStyle="labelStyle">{{
        userInfo.other_area_str.join(",")
      }}</el-descriptions-item>
      <el-descriptions-item label="技能证书" :labelStyle="labelStyle">
        <span v-if="userInfo.is_certificate == 2">不涉及</span>
        <div v-else style="display: flex">
          <div
            v-for="(i, idex) in userInfo.kind_certificate"
            :key="idex"
            style="
              margin-right: 10px;
              display: flex;
              flex-direction: column;
              align-items: center;
            "
          >
            <template v-if="i.image">
              <div
                style="width: 60px; height: 40px; cursor: pointer"
                @click="previewCert(i.image)"
              >
                <el-image style="width: 100%; height: 100%" :src="i.image">
                  <div slot="error">暂无照片</div>
                </el-image>
              </div>
              <div style="text-align: center">{{ i.name }}</div>
            </template>
            <template v-else>
              <img
                style="width: 60px; height: 40px"
                :src="require('@/assets/img/no-pic.png')"
                alt=""
              />
              <div style="text-align: center; margin-top: 4px">
                {{ i.name }}
              </div>
            </template>
          </div>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <p v-else>无名片信息</p>
    <el-divider v-if="applyInfo.apply_fee == 1"></el-divider>
    <!-- "apply_fee": 1, //是否报名费 1:是 0:否 -->
    <div class="action-row" v-if="applyInfo.apply_fee == 1">
      <div v-if="applyInfo.create_time">
        <!-- "status": 1, //状态 0:已报名 1:已雇佣（报名成功）2:未录用 3:报名失败 -->
        <!-- is_refund  是否退款 1:是 0:否 -->
        <div>支付报名费￥{{ applyInfo.apply_amount }}</div>
        <div>{{ applyInfo.create_time }}</div>
      </div>
      <div v-if="applyInfo.check_time && applyInfo.status == 1">
        <div>已录用</div>
        <div>{{ applyInfo.check_time }}</div>
      </div>
      <div v-if="applyInfo.check_time && applyInfo.status == 2">
        <div>未录用</div>
        <div>{{ applyInfo.check_time }}</div>
      </div>
      <div v-if="applyInfo.status == 3">
        <div>报名失败</div>
        <div>{{ applyInfo.check_time }}</div>
      </div>
      <div v-if="applyInfo.is_refund == 1">
        <div>退款成功</div>
        <div>{{ applyInfo.refund_time }}</div>
      </div>
      <!-- <div v-if="applyInfo.status == 0">
        <el-button type="danger" size="mini" @click="checkNo"
          >拒绝录用</el-button
        >
        <el-button type="primary" size="mini" @click="checkYes"
          >确认录用</el-button
        >
      </div> -->
      <!-- <div v-if="applyInfo.status > 0 && applyInfo.is_refund == 0">
        <el-button type="primary" size="mini" @click="refoundAmount"
          >退报名费</el-button
        >
      </div> -->
    </div>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">关闭</el-button>
      </el-row>
    </template>
    <!-- 技能证书预览（带水印） -->
    <el-dialog
      append-to-body
      width="700px"
      custom-class="cert-preview-dialog"
      :visible.sync="certPreviewVisible"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :show-close="false"
    >
      <div class="cert-preview-outer">
        <div class="cert-preview-wrap">
          <img :src="certPreviewUrl" class="cert-preview-img" />
          <div class="cert-watermark">
            <div v-for="r in 4" :key="'r' + r" class="wm-row">
              <span v-for="c in 4" :key="'c' + r + '-' + c" class="wm-cell"
                >悟有空管理端</span
              >
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      labelStyle: { width: "160px" },
      info: {},
      userInfo: {},
      applyInfo: {},
      certPreviewVisible: false,
      certPreviewUrl: "",
    };
  },
  methods: {
    previewCert(url) {
      this.certPreviewUrl = url;
      this.certPreviewVisible = true;
    },
    // 获取详情
    getDetail(row) {
      this.info = row;
      this.init();
    },
    init() {
      // apply_id为招工详情所用
      this.$http
        .get("/agency/user/info", {
          params: { id: this.info.user_id, apply_id: this.info.id },
        })
        .then((res) => {
          if (res.code == 1) {
            this.userInfo = res.data.certification;
            this.applyInfo = res.data.apply;
          }
        });
    },
    reset(done) {
      this.userInfo = {};
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
  },
};
</script>
<style lang="scss">
.cert-preview-dialog .el-dialog__header {
  padding: 10px 20px;
}
.cert-preview-dialog .el-dialog__body {
  padding: 10px 20px 20px;
}
</style>
<style lang="scss" scoped>
.cert-preview-outer {
  text-align: center;
}
.cert-preview-wrap {
  position: relative;
  display: inline-block;
  .cert-preview-img {
    max-width: 100%;
    max-height: 600px;
    display: block;
  }
  .cert-watermark {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    pointer-events: none;
    user-select: none;
    transform: rotate(-30deg);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .wm-row {
      display: flex;
      justify-content: space-around;
      .wm-cell {
        color: rgba(204, 204, 204, 1);
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 2px;
        white-space: nowrap;
      }
    }
  }
}
.action-row {
  display: flex;
  gap: 30px;
}
</style>
